module.exports = __webpack_public_path__ + "static/huffington-post-e871f0e2da023ed11cf758ba1d1b3bfa.svg";